import { Truck, Shield, Users, Award, Target, Heart } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_8e64f860-a2c3-4880-99a2-0e37e54f65c6/artifacts/lq6grz4s_CB3D4111-0127-441A-AEB4-FB146D6CBB1E.png";

export default function About() {
  const values = [
    { icon: Target, title: 'Quality First', desc: 'We source only the best products from trusted suppliers worldwide.' },
    { icon: Heart, title: 'Customer Focus', desc: 'Your satisfaction is our top priority. We go above and beyond to serve you.' },
    { icon: Shield, title: 'Trust & Security', desc: 'Shop with confidence knowing your data and transactions are protected.' },
    { icon: Truck, title: 'Fast Delivery', desc: 'Quick and reliable shipping to get your orders to you promptly.' },
  ];

  const stats = [
    { value: '50K+', label: 'Happy Customers' },
    { value: '10K+', label: 'Products' },
    { value: '99%', label: 'Satisfaction Rate' },
    { value: '24/7', label: 'Support' },
  ];

  return (
    <div className="min-h-screen bg-[#F8FAFC]" data-testid="about-page">
      {/* Hero */}
      <section className="bg-[#003366] py-16 md:py-24">
        <div className="max-w-[1440px] mx-auto px-4 text-center">
          <img src={LOGO_URL} alt="IPVALUE Managements" className="h-20 mx-auto mb-6" />
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4">About IPVALUE MANAGEMENTS</h1>
          <p className="text-slate-300 max-w-2xl mx-auto text-lg">
            Your trusted destination for quality products at unbeatable prices. 
            We're committed to delivering exceptional value and service to every customer.
          </p>
        </div>
      </section>

      {/* Stats */}
      <section className="py-12 bg-white border-b">
        <div className="max-w-[1440px] mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, i) => (
              <div key={i} className="text-center">
                <p className="text-3xl md:text-4xl font-bold text-[#003366]">{stat.value}</p>
                <p className="text-slate-500">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-16 md:py-24">
        <div className="max-w-[1440px] mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4">Our Story</h2>
              <div className="space-y-4 text-slate-600">
                <p>
                  Founded with a vision to make quality products accessible to everyone, 
                  IPVALUE MANAGEMENTS has grown from a small operation into a trusted e-commerce platform 
                  serving thousands of customers nationwide.
                </p>
                <p>
                  Under the umbrella of IPVALUE Managements, we combine decades of retail 
                  experience with cutting-edge technology to deliver an unmatched shopping experience. 
                  Our team is passionate about finding the best deals and bringing them directly to you.
                </p>
                <p>
                  We believe that everyone deserves access to quality products without breaking the bank. 
                  That's why we work tirelessly to negotiate the best prices and pass the savings on to our customers.
                </p>
              </div>
            </div>
            <div className="bg-gradient-to-br from-[#003366] to-[#002244] rounded-2xl p-8 text-white">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 bg-[#FFD700]/20 rounded-full flex items-center justify-center">
                  <Award size={32} className="text-[#FFD700]" />
                </div>
                <div>
                  <h3 className="text-xl font-bold">IPVALUE Managements</h3>
                  <p className="text-slate-300">A Trusted Name Since 2020</p>
                </div>
              </div>
              <p className="text-slate-300">
                "Our mission is simple: deliver value, build trust, and exceed expectations. 
                Every product we sell, every order we ship, and every customer we serve 
                brings us closer to this mission."
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-[1440px] mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-12 text-center">
            Our Core Values
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((value, i) => (
              <div key={i} className="bg-slate-50 rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-[#003366] rounded-full flex items-center justify-center mx-auto mb-4">
                  <value.icon className="text-[#FFD700]" size={28} />
                </div>
                <h3 className="font-bold text-slate-900 mb-2">{value.title}</h3>
                <p className="text-slate-500 text-sm">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="py-16 md:py-24">
        <div className="max-w-[1440px] mx-auto px-4 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4">Our Team</h2>
          <p className="text-slate-500 max-w-2xl mx-auto mb-12">
            Behind IPVALUE MANAGEMENTS is a dedicated team of professionals committed to delivering 
            the best shopping experience possible.
          </p>
          <div className="flex items-center justify-center gap-4">
            <div className="w-12 h-12 bg-[#003366] rounded-full flex items-center justify-center">
              <Users className="text-white" size={24} />
            </div>
            <span className="text-slate-600">50+ Team Members Across the Globe</span>
          </div>
        </div>
      </section>
    </div>
  );
}
